/*
* SundAir2019Plugin.js
*
* Description: This is our plugin object. It can be exported to be used anywhere.
*
* This file is part of: "http://apps.sundair.com/", "SunCrew - Reports"
* Copyright 2018,2019,2020,2021 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Phillip Alsleben <phillip.alsleben@sundair.com>
* @author Learek <michael.broeker@sundair.com>
*
*/
// import { CONF_ENVIRONMENT }  from '../config.js';

import dayjs from 'dayjs';


const SundAir2021Plugin = {

    install(Vue) { // options

        Vue.loader = '';

        /***********************************************************************
        * Global: make_basic_auth()
        *
        * Desc: Build 'Authorization' Key for API Calls.
        * Note: At 'Login' .. params are passed.
        *
        */
        Vue.prototype.$make_basic_auth = function (params) {

            var Base64 = {},
                token,
                hash,
                user = params.username ? params.username : 'booking_website',
                password = params.password ? params.password : 'D1sq3ccfwests!';


            Base64 = {
                // private property
                keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',

                // public method for encoding
                encode: function (input) {
                    var output = '',
                        chr1,
                        chr2,
                        chr3,
                        enc1,
                        enc2,
                        enc3,
                        enc4,
                        i = 0;

                    input = Base64.utf8_encode(input);

                    while (i < input.length) {
                        chr1 = input.charCodeAt(i++);
                        chr2 = input.charCodeAt(i++);
                        chr3 = input.charCodeAt(i++);

                        enc1 = chr1 >> 2;
                        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                        enc4 = chr3 & 63;

                        if (isNaN(chr2)) {
                            enc3 = enc4 = 64;
                        } else if (isNaN(chr3)) {
                            enc4 = 64;
                        }

                        output = output + this.keyStr.charAt(enc1) + this.keyStr.charAt(enc2) + this.keyStr.charAt(enc3) + this.keyStr.charAt(enc4);
                    }

                    return output;
                },
                // private method for UTF-8 encoding
                utf8_encode: function (string) {
                    var utftext = '',
                        n,
                        c;

                    string = string.replace(/\r\n/g, '\n');

                    for (n = 0; n < string.length; n++) {
                        c = string.charCodeAt(n);

                        if (c < 128) {
                            utftext += String.fromCharCode(c);
                        } else if (c > 127 && c < 2048) {
                            utftext += String.fromCharCode((c >> 6) | 192);
                            utftext += String.fromCharCode((c & 63) | 128);
                        } else {
                            utftext += String.fromCharCode((c >> 12) | 224);
                            utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                            utftext += String.fromCharCode((c & 63) | 128);
                        }
                    }

                    return utftext;
                }
            };

            token = user + ':' + password;
            hash = Base64.encode(token);


            return 'Basic ' + hash;

        }; // eof make_basic_auth()


        /***********************************************************************
        * Global: header_language()
        *
        * Desc: Right Header Language to send.
        * Note:
        *
        */
        Vue.prototype.$header_language = function () {

            var lang = 'DE',
                localStorageLanguage = JSON.parse(localStorage.getItem('sdr__lang')); // catch


            // Language in localStrage?
            if (localStorageLanguage !== null) {
                lang = localStorageLanguage.value.toUpperCase();
            }

            return lang;

        }; // eo function header_language()


        /***********************************************************************
        * Global: lookUpCurrentBase()
        *
        * Desc: Returns the current base the resource in based.
        * Note: If no Base History Entry found, return null.
        *
        * @param {Object[]} m (Base History List)
        *
        * @returns {Object | null} (BaseHistoryEntry)
        */
        Vue.prototype.$lookUpCurrentBase = function (baseHistory) {

            let baseHistory_Filtered = [],
                baseStationEntryToReturn = null;


            //filter out every base in the future
            baseHistory_Filtered = baseHistory.filter((b) => dayjs(b.sinceDate).startOf('day').isBefore(dayjs()));

            //sort by date
            baseHistory_Filtered.sort((a, b) => a.sinceDate < b.sinceDate ? 1 : -1);

            //take the first one as shown base
            if (baseHistory_Filtered.length > 0) {
                baseStationEntryToReturn = baseHistory_Filtered[0];
            }


            return baseStationEntryToReturn;

        }; // eo function lookUpCurrentBase()


        /***********************************************************************
        * Global: vp_m()
        *
        * Desc: Mask Viewport.
        * Note: Loader Config here.
        *
        */
        Vue.prototype.$vp_m = function () {

            Vue.loader = this.$loading.show({
                // container: this.$refs.loadingContainer, // ?
                canCancel: false, // default false
                color: '#9F4378',
                loader: 'spinner',
                width: 64,
                height: 64,
                backgroundColor: '#ffffff',
                opacity: 0.5
            });

        }; // eo function vp_m()


        /***********************************************************************
        * Global: vp_m()
        *
        * Desc: Unmask Viewport.
        * Note:
        *
        */
        Vue.prototype.$vp_um = function () {

            Vue.loader.hide();

        }; // eo function vp_um()


        /***********************************************************************
        * Global: toc()
        *
        * Desc: Application Infos while Debugging.
        * Note: Now via config.js.
        *
        * @param {String} m (Message to log)
        */
        Vue.prototype.$toc = function (m) {

            var rm = 'PROD'; // CONF_ENVIRONMENT;


            if (rm === 'DEV') {
                console.log(m);
            }

        }; // eo function toc()

    } // eo install
};

export default SundAir2021Plugin;